
import { Language } from '../types';
import { homeTranslations } from './home';
import { navigationTranslations } from './navigation';
import { ecommerceTranslations } from './ecommerce';
import { productManagementTranslations } from './productManagement';
import { talkToDataTranslations } from './talkToData';
import { dataPlatformTranslations } from './dataPlatform';
import { sasMigrationsTranslations } from './sasMigrations';
import { aboutTranslations } from './about';

// Merge all translations into a single object
export const translations: Record<Language, Record<string, string>> = {
  en: {
    ...homeTranslations.en,
    ...navigationTranslations.en,
    ...ecommerceTranslations.en,
    ...productManagementTranslations.en,
    ...talkToDataTranslations.en,
    ...dataPlatformTranslations.en,
    ...sasMigrationsTranslations.en,
    ...aboutTranslations.en,
  },
  de: {
    ...homeTranslations.de,
    ...navigationTranslations.de,
    ...ecommerceTranslations.de,
    ...productManagementTranslations.de,
    ...talkToDataTranslations.de,
    ...dataPlatformTranslations.de,
    ...sasMigrationsTranslations.de,
    ...aboutTranslations.de,
  },
  sk: {
    ...homeTranslations.sk,
    ...navigationTranslations.sk,
    ...ecommerceTranslations.sk,
    ...productManagementTranslations.sk,
    ...talkToDataTranslations.sk,
    ...dataPlatformTranslations.sk,
    ...sasMigrationsTranslations.sk,
    ...aboutTranslations.sk,
  },
  cs: {
    ...homeTranslations.cs,
    ...navigationTranslations.cs,
    ...ecommerceTranslations.cs,
    ...productManagementTranslations.cs,
    ...talkToDataTranslations.cs,
    ...dataPlatformTranslations.cs,
    ...sasMigrationsTranslations.cs,
    ...aboutTranslations.cs,
  }
};
